import React from 'react';

const ContinuationChainTable = ({ chainData, formatDate, getStatusIcon, getStatusText, t }) => {
  if (!chainData || chainData.length === 0) {
    return (
      <div className="text-center py-4 text-sm text-gray-600 dark:text-gray-400">
        {t('massUpload.noChainData') || 'No job chain data available.'}
      </div>
    );
  }
  
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 dark:bg-gray-800/50">
          <tr>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-600 dark:text-gray-400">{t('massUpload.jobPart')}</th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-600 dark:text-gray-400">{t('massUpload.startTime')}</th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-600 dark:text-gray-400">{t('massUpload.status')}</th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-600 dark:text-gray-400">{t('massUpload.completed')}</th>
            <th className="px-3 py-2 text-left text-xs font-medium text-gray-600 dark:text-gray-400">{t('massUpload.matches')}</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
          {chainData.map((job, index) => (
            <tr key={job.id} className={`
              hover:bg-gray-50 dark:hover:bg-gray-700/30
              ${job.status === 'processing' ? 'bg-blue-50 dark:bg-blue-900/20' : ''}
              ${job.status === 'continued' ? 'bg-indigo-50 dark:bg-indigo-900/20' : ''}
              ${job.status === 'completed-with-matches' ? 'bg-yellow-50 dark:bg-yellow-900/20' : ''}
              ${job.status === 'error' ? 'bg-red-50 dark:bg-red-900/20' : ''}
            `}>
              <td className="px-3 py-2">
                <div className="flex items-center">
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-300 mr-2">
                    {index + 1}
                  </span>
                  <span className="font-mono text-xs">{(job.id || 'N/A').substring(0, 12)}...</span>
                </div>
              </td>
              <td className="px-3 py-2">{formatDate(job.startTime)}</td>
              <td className="px-3 py-2">
                <div className="flex items-center gap-1.5">
                  <span className={`
                    inline-flex items-center justify-center w-4 h-4
                    ${job.status === 'processing' ? 'text-blue-600 dark:text-blue-400' : ''}
                    ${job.status === 'continued' ? 'text-indigo-600 dark:text-indigo-400' : ''}
                    ${job.status === 'completed' ? 'text-green-600 dark:text-green-400' : ''}
                    ${job.status === 'completed-with-matches' ? 'text-yellow-600 dark:text-yellow-400' : ''}
                    ${job.status === 'error' ? 'text-red-600 dark:text-red-400' : ''}
                  `}>
                    {getStatusIcon(job.status)}
                  </span>
                  <span className={`
                    ${job.status === 'processing' ? 'text-blue-600 dark:text-blue-400' : ''}
                    ${job.status === 'continued' ? 'text-indigo-600 dark:text-indigo-400' : ''}
                    ${job.status === 'completed' ? 'text-green-600 dark:text-green-400' : ''}
                    ${job.status === 'completed-with-matches' ? 'text-yellow-600 dark:text-yellow-400' : ''}
                    ${job.status === 'error' ? 'text-red-600 dark:text-red-400' : ''}
                    text-xs font-medium
                  `}>
                    {job.status === 'continued' ? 'Continued' : getStatusText(job.status)}
                  </span>
                </div>
              </td>
              <td className="px-3 py-2">
                {job.progress?.completed ?? 0} / {job.progress?.total ?? 0}
              </td>
              <td className="px-3 py-2">
                {job.progress?.totalMatches ?? 0}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContinuationChainTable; 